import { createFileRoute, notFound } from '@tanstack/react-router';
import ViewAnalyte from '../../../../pages/viewAnalyte/ViewAnalyte';
import { VIEW_ANALYTE_PAGE } from '../../../../utils/permissions';

export const Route = createFileRoute(
  '/_authenticated/_navbar/analyte/$analyteId'
)({
  beforeLoad: ({ context }) => {
    if (!context.auth.hasPermission(VIEW_ANALYTE_PAGE)) {
      throw notFound();
    }
  },
  component: ViewAnalyte,
});
